import styled from 'styled-components';
import React, { useContext, useMemo } from 'react';
import { LabelsList } from '@/components/labels-list';
import { PriceTestContext } from '@/features/editor/widgets/price-test/context';

export function PriceTestStepPages() {
  const { props, setProps } = useContext(PriceTestContext);

  const labels = useMemo(() => {
    const initials = [
      { label: `Homepage`, isSelected: props?.pages?.homepage },
      { label: `Product page`, isSelected: props?.pages?.productPage },
      { label: `Collection page`, isSelected: props?.pages?.collections },
      { label: `Search results`, isSelected: props?.pages?.search },
      { label: `Cart`, isSelected: props?.pages?.cart },
      { label: `Quiz`, isSelected: props?.pages?.quiz },
      { label: `Popups`, isSelected: props?.pages?.popups },
      { label: `Blogs`, isSelected: props?.pages?.blogs },
    ];

    return initials;
  }, [props?.pages]);

  const onLabelSelected = async (selectedLabels: string[]) => {
    setProps((draft) => {
      draft.pages.homepage = selectedLabels.includes(`Homepage`);
      draft.pages.productPage = selectedLabels.includes(`Product page`);
      draft.pages.collections = selectedLabels.includes(`Collection page`);
      draft.pages.search = selectedLabels.includes(`Search results`);
      draft.pages.cart = selectedLabels.includes(`Cart`);
      draft.pages.quiz = selectedLabels.includes(`Quiz`);
      draft.pages.popups = selectedLabels.includes(`Popups`);
      draft.pages.blogs = selectedLabels.includes(`Blogs`);
      draft.pages.others = selectedLabels.filter(
        (label) =>
          label !== `Homepage` &&
          label !== `Product page` &&
          label !== `Collection page` &&
          label !== `Search results` &&
          label !== `Cart` &&
          label !== `Quiz` &&
          label !== `Popups` &&
          label !== `Blogs`,
      );
    });
  };

  return (
    <Wrapper>
      <h3>5. Select the pages that your product might appear in</h3>
      <LabelsList
        allowAppend
        maxHeight="100rem"
        appendText="Other"
        appendPosition="last"
        collapseAfter={50}
        labels={labels}
        onLabelSelection={onLabelSelected}
        bypassSort
      />
    </Wrapper>
  );
}

const Wrapper = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 2rem;
  padding: 1rem 0;

  h3 {
    margin: 0;
    padding: 0;
    font-size: 1.2rem;
    color: #8f969e;
    font-weight: normal;
  }

  div[class*='labels-list'] .selectable-removable {
    box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0),
      0 0.5px 0.5px 0 rgba(0, 0, 0, 0.15);
    background-color: #eaf0f6;
  }

  div[class*='labels-list'] .selected {
    background-color: #ffffff;
    color: #3b47ff;
    box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0),
      0 6.5px 8px 0 rgba(151, 210, 206, 0.22),
      0 0.5px 0.5px 0 rgba(0, 0, 0, 0.15);
  }

  .label-controls {
    display: none;
  }
`;
